export const TERMS_URL = 'https://online.vincentcapital.co.nz/terms.html'
export const PRIVACY_URL = 'https://online.vincentcapital.co.nz/privacy.html'
export const FAQ_URL = 'https://online.vincentcapital.co.nz/#faq'
